import { useDropzone } from "react-dropzone";
import Text from "@ingka/text";
import { CreateUploadDtoTypeEnum } from "generated";
import { useToast } from "@/hooks/toast";
import { acceptedMimeTypes } from "./constants";

type Props = {
  uploadType: CreateUploadDtoTypeEnum;
  onFilesSelected: (files: File[]) => void;
};

export const FilesDropZone = ({
  uploadType = "IMAGE",
  onFilesSelected,
}: Props) => {
  const { toast } = useToast();
  const { getRootProps, getInputProps } = useDropzone({
    accept: acceptedMimeTypes[uploadType],
    onDrop: (acceptedFiles: File[]) => {
      onFilesSelected(acceptedFiles);
    },
    onDropRejected: (fileRejections) => {
      toast(
        `The following file(s) type are not accepted: ${fileRejections.map((file) => file.file.name).join(", ")}`,
      );
    },
  });

  return (
    <div
      {...getRootProps()}
      className="flex h-[14rem] w-[45rem] cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed border-black/45"
    >
      <input {...getInputProps({ "aria-label": "Upload files" })} />
      <Text tagName="span" bodySize="s">
        Drag and drop files here or click <b>here</b> to browse your computer.
      </Text>
      <Text tagName="span" bodySize="s">
        Recommended formats:{" "}
        {Object.values(acceptedMimeTypes[uploadType])
          .flat()
          .map((type) => type.replace(".", ""))
          .join(", ")}
      </Text>
    </div>
  );
};
